import { IntegrationAppsComponent } from './integration-apps.component';
import { IntegrationAppsHubComponent } from './pages/integration-apps-hub/integration-apps-hub.component';
import { IntegrationAppsMarketplaceComponent } from './pages/integration-apps-marketplace/integration-apps-marketplace.component';
import { IntegrationAppsDetailsComponent } from './pages/integration-apps-details/integration-apps-details.component';
import { IntegrationAppsCardComponent } from './components/integration-apps-card/integration-apps-card.component';
import { IntegrationAppsDetailCardComponent } from './components/integration-apps-detail-card/integration-apps-detail-card.component';
import { IntegrationAppsResourcesCardComponent } from './components/integration-apps-resources-card/integration-apps-resources-card.component';
import { IntegrationAppsDialogComponent } from './pages/integration-apps-dialog/integration-apps-dialog.component';
import { IntegrationAppsCardLongComponent } from './components/integration-apps-card-long/integration-apps-card-long.component';
import { IntegrationAppsCreationEditorComponent } from './pages/integration-apps-creation-editor/integration-apps-creation-editor.component';
import { IntegrationAppsPermissionSecretsComponent } from './components/integration-apps-permission-secrets/integration-apps-permission-secrets.component';
import { IntegrationAppsInstanceProvisioningTypeCardComponent } from './components/integration-apps-instance-provisioning-type-card/integration-apps-instance-provisioning-type-card.component';
import { IntegrationAppInformationFormComponent } from './forms/integration-app-information-form/integration-app-information-form.component';
import { InstanceProvisioningLabelFormComponent } from './forms/instance-provisioning-label-form/instance-provisioning-label-form.component';
import { IntegrationAppsInstanceProvisioningDialogComponent } from './pages/integration-apps-instance-provisioning-dialog/integration-apps-instance-provisioning-dialog.component';

export const integrationAppsComponents = [
  IntegrationAppsComponent,
  IntegrationAppsHubComponent,
  IntegrationAppsMarketplaceComponent,
  IntegrationAppsDetailsComponent,
  IntegrationAppsCardComponent,
  IntegrationAppsCardLongComponent,
  IntegrationAppsDetailCardComponent,
  IntegrationAppsResourcesCardComponent,
  IntegrationAppsDialogComponent,
  IntegrationAppsCreationEditorComponent,
  IntegrationAppInformationFormComponent,
  IntegrationAppsPermissionSecretsComponent,
  IntegrationAppsInstanceProvisioningTypeCardComponent,
  InstanceProvisioningLabelFormComponent,
  IntegrationAppsInstanceProvisioningDialogComponent
]
